import styled from 'styled-components';

export const Container = styled.div`
    > .form {
        > div:first-child {
            margin-bottom: 64px;
        }
    }
`;
